import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import { useCart } from '../../context/CartContext';

const Cart = ({ onClose }) => {
  const { cartItems, removeFromCart, checkout, loading } = useCart();
  const navigate = useNavigate();

  const handleCheckout = async () => {
    try {
      await checkout();
      alert('Appointments confirmed! Check your email.');
      onClose();
      navigate('/dashboard');
    } catch (error) {
      alert('Checkout failed. Please try again.');
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-end">
      <div className="bg-white w-full max-w-md h-full overflow-y-auto p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-light text-primary">Your Cart</h2>
          <button onClick={onClose} className="text-primary hover:text-secondary">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {cartItems.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-primary mb-4">Your cart is empty</p>
            <button onClick={onClose} className="btn-primary">Continue Booking</button>
          </div>
        ) : (
          <>
            <div className="space-y-4 mb-6">
              {cartItems.map((item) => (
                <div key={item.id} className="border border-secondary rounded-lg p-4">
                  <div className="flex justify-between items-start mb-2">
                    <div>
                      <p className="text-primary font-medium">
                        {format(new Date(item.appointment_date), 'MMM d, yyyy')}
                      </p>
                      <p className="text-sm text-primary">{item.start_time}</p>
                      <p className="text-sm text-primary">{item.duration_minutes} minutes</p>
                    </div>
                    <button
                      onClick={() => removeFromCart(item.id)}
                      className="text-red-600 hover:text-red-800"
                    >
                      Remove
                    </button>
                  </div>
                  <p className="text-xs text-gray-500">
                    Expires: {format(new Date(item.expires_at), 'h:mm a')}
                  </p>
                </div>
              ))}
            </div>

            <button
              onClick={handleCheckout}
              disabled={loading}
              className="w-full btn-primary disabled:opacity-50"
            >
              {loading ? 'Processing...' : 'Checkout (' + cartItems.length + ' items)'}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default Cart;
